// components/StatCard.jsx — tuile KPI compacte, partagée entre le dashboard
// SuperAdmin (Tenants/MRR/ARR…) et l'onglet Système (Statut PM2/Uptime…).
// Layout sur une seule ligne (icône + libellé à gauche, valeur à droite) au
// lieu d'un empilement icône/libellé puis valeur en dessous — beaucoup plus
// compact verticalement, surtout utile sur les grilles de 5-6 tuiles.
export default function StatCard({ label, value, icon: Icon, color }) {
  return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10,
      padding:'11px 14px', background:'#13141a', borderRadius:10, border:'1px solid #2a2b35' }}>
      <div style={{ display:'flex', alignItems:'center', gap:8, minWidth:0 }}>
        <div style={{ width:26, height:26, borderRadius:7, background:`${color}22`,
          display:'flex', alignItems:'center', justifyContent:'center', flexShrink:0 }}>
          <Icon size={13} color={color}/>
        </div>
        <span style={{ color:'#888', fontSize:11.5, whiteSpace:'nowrap', overflow:'hidden',
          textOverflow:'ellipsis' }}>{label}</span>
      </div>
      <div style={{ fontSize:17, fontWeight:800, color:'#fff', flexShrink:0, whiteSpace:'nowrap' }}>{value}</div>
    </div>
  );
}